import React, {useState} from 'react';
import {Page, Layout, EmptyState} from "@shopify/polaris";
import {ResourcePicker, TitleBar} from '@shopify/app-bridge-react';
import {SelectPayload} from "@shopify/app-bridge-react/components/ResourcePicker/ResourcePicker";

const img = 'https://cdn.shopify.com/s/files/1/0757/9955/files/empty-state.svg';

export default function ShopifyAppBridgeTest() {
    const [ open, setOpen ] = useState(false);
    //const [ ids, setIds ] = useState<string[] | null>(null);

    const handleSelection = (resources: SelectPayload) => {
        console.log("handleSelection", resources);
        setOpen(false);
        const idsFromResources = resources.selection.map((product) => product.id);
        console.log("setIds", idsFromResources);
        //setIds(idsFromResources);
    };

    return (
        <Page>
            <TitleBar
                title="App Bridge Test"
                primaryAction={{
                    content: 'Select products',
                    onAction: () => setOpen(true)
                }}
            />
            <ResourcePicker // Resource picker component
                resourceType="Product"
                showVariants={false}
                open={open}
                onSelection={handleSelection}
                onCancel={() => setOpen(false)}
            />
            <Layout>
                <EmptyState
                    heading="Discount your products temporarily"
                    action={{
                        content: 'Select products',
                        onAction: () => setOpen(true)
                    }}
                    image={img}
                >
                    <p>Select products to change their price temporarily.</p>
                </EmptyState>
            </Layout>
        </Page>
    );
}
